import Vue from 'vue';

const template = `
<transition name="fade">
    <div class="modal" :class='mainClass' @click.self='$emit("close")' :style='{zIndex: zIndex}'>
        <div class='modal__inner' :style='{width: width, maxWidth: maxWidth}' @click.self='$emit("close")'>
            <div class='modal__content'>
<!--                <div class='modal__close' @click.stop='$emit("close")'><i class='img-close'></i></div>-->
                <slot></slot>
            </div>
        </div>
    </div>
</transition>
`;

export default Vue.extend({
  props: {
    mainClass: { type: String, default: '' },
    width: { type: String, default: '100%' },
    maxWidth: { type: String, default: '1300px' },
    zIndex: { type: Number, default: 5000 }
  },
  template: template
});
